export const slugify = (string, maxLength) => {
  let s = string
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-") // Replace non-alphanumeric chars with hyphens
    .replace(/(^-|-$)/g, "") // Remove leading or trailing hyphens

  if (s.match(/^[0-9-]/)) {
    s = "_" + s
  }

  if (maxLength && s.length > maxLength) {
    s = s.slice(0, maxLength)
    s = s.slice(0, s.lastIndexOf("-"))
  }

  return s
}

export default slugify
